import React, { useRef } from "react";
import { Box, Typography } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import i18next from "i18next";

const ImageUploader = ({ logoUrl, setLogoUrl, onUpload }) => {
  console.log("logo url inside component------------->", logoUrl);
  const fileInputRef = useRef();

  // const handleFileChange = (e) => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     const url = URL.createObjectURL(file);
  //     setLogoUrl(url);
  //   }
  // };

  // const handleDrop = (e) => {
  //   e.preventDefault();
  //   const file = e.dataTransfer.files[0];
  //   if (file) {
  //     const url = URL.createObjectURL(file);
  //     setLogoUrl(url);
  //   }
  // };

  return (
    <Box
      onClick={() => fileInputRef.current.click()}
      onDrop={onUpload}
      onDragOver={(e) => e.preventDefault()}
      sx={{
        border: "2px dashed #2196f3",
        borderRadius: "8px",
        padding: "20px",
        textAlign: "center",
        cursor: "pointer",
        backgroundColor: "#f9f9f9",
        color: "#2196f3",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "60px",
      }}
    >
      <input
        type="file"
        accept="image/*"
        ref={fileInputRef}
        hidden
        onChange={onUpload}
      />
      <Box sx={{ display: "flex", gap: 3 }}>
        <Typography variant="body2">
          {logoUrl?.length > 0
            ? i18next.t("Image Uploaded")
            : i18next.t("Drag & Drop files or Browse")}
        </Typography>
        <CloudUploadIcon sx={{ fontSize: 24 }} />
      </Box>
    </Box>
  );
};

export default ImageUploader;
